/* Nardocar — Typesense-powered search (InstantSearch.js + adapter).
 * Config is injected by sections/typesense-search.liquid as window.nardoSearch.
 * Renders one card per product (group_by product_id) with facets + sorting.
 * Used by sections/typesense-search.liquid (/search); collection pages use
 * typesense-search-brands-v9.js.
 * Loaded as-is: Shopify minifies theme JS assets on the CDN, so there is no
 * checked-in .min.js to keep in sync. */
(function () {
  "use strict";

  // Retry-mekanisme: vent på at dependencies er loadet (defer scripts kan have race conditions)
  // carTitleAttrs ligger uden for tryInit og kan ikke se dens esc() – egen kopi her (ellers ReferenceError, og hele gitteret fejler).
  function escAttr(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* Data for assets/nc-car-title.js (dynamic title after the saved car), as snippets/nc-car-title-attrs.liquid gives Liquid cards. */
  function carTitleAttrs(hit) {
    var tags = hit.tags || [];
    if (tags.indexOf("nc-biltitel") < 0) return "";
    var pick = function (p) { return tags.filter(function (t) { return t.indexOf(p) === 0; }).map(function (t) { return t.slice(p.length); }); };
    var models = pick("model_id:");
    if (!models.length) return "";
    return ' data-nc-ct data-models="' + escAttr(models.join(",")) + '" data-types="' + escAttr(pick("vehicle_type_id:").join(",")) +
      '" data-makes="' + escAttr(pick("make:").join("|")) + '" data-title="' + escAttr(hit.title) + '"' + (tags.indexOf("nc-titel-neutral") > -1 ? ' data-neutral="1"' : "");
  }

  function tryInit(attempts) {
    var cfg = window.nardoSearch;
    if (!cfg || !window.instantsearch || !window.TypesenseInstantSearchAdapter) {
      if (attempts > 0) {
        setTimeout(function() { tryInit(attempts - 1); }, 200);
      } else {
        console.error("[nardo-search] missing config or libraries after retries");
      }
      return;
    }
    runSearch(cfg);
  }

  function runSearch(cfg) {

  var instantsearch = window.instantsearch;
  var COLLECTION = cfg.collection;

  // All customer-facing strings come from the global config snippet (locales/*.json).
  var L = cfg.labels || {};
  var HITS_PER_PAGE = cfg.hitsPerPage || 24;

  // Facet counts. Prices replay the shop's own money_format (e.g.
  // "{{amount_no_decimals_with_comma_separator}} kr") so they match the native
  // `money` filter exactly, in every market.
  var num = new Intl.NumberFormat(cfg.locale || "da-DK", { maximumFractionDigits: 0 });
  var MONEY_FORMAT = String(cfg.moneyFormat || "{{amount_no_decimals_with_comma_separator}} kr")
    .replace(/<[^>]*>/g, "");
  var AMOUNT_RE = /\{\{\s*\w+\s*\}\}/;
  var moneyDigits = MONEY_FORMAT.indexOf("no_decimals") > -1 ? 0 : 2;
  var amountFmt = new Intl.NumberFormat(cfg.locale || "da-DK", {
    minimumFractionDigits: moneyDigits,
    maximumFractionDigits: moneyDigits,
  });
  var money = { format: function (n) { return MONEY_FORMAT.replace(AMOUNT_RE, amountFmt.format(n)); } };
  // Currency-only part of the format ("kr"), for the price slider's suffix.
  var CURRENCY = MONEY_FORMAT.replace(AMOUNT_RE, "").trim();

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ── card settings passthrough (window.nardoSearch.card, see sections) ─
  var card = cfg.card || {};
  var CARD_LABELS = card.labels || {};

  // settings.color_swatches: newline "Name: #hex" list → { Name: "#hex" }.
  var SWATCH_COLORS = {};
  String(card.colorSwatches || "").split(/\r?\n/).forEach(function (line) {
    var i = line.indexOf(":");
    if (i > 0) SWATCH_COLORS[line.slice(0, i).trim()] = line.slice(i + 1).trim();
  });
  var SWATCH_OPTIONS = (card.optionSwatches || [])
    .map(function (s) { return String(s).trim(); })
    .filter(Boolean);

  // New card fields (template_suffix, card_specs, swatches, …) only exist in
  // freshly synced Typesense docs — every consumer below must treat a missing
  // field as "don't render", never as an error.
  function parseJSONField(s) {
    if (s == null || s === "") return null;
    if (typeof s !== "string") return s;
    try { return JSON.parse(s); } catch (e) { return null; }
  }

  // "gid://shopify/ProductVariant/123" → "123"
  function numericId(gid) {
    var m = String(gid == null ? "" : gid).match(/(\d+)\s*$/);
    return m ? m[1] : "";
  }

  // Mirrors card-product.liquid's is_pre_order (template_suffix "pre-order"
  // or "pre-order-*").
  function isPreOrder(hit) {
    return typeof hit.template_suffix === "string" && hit.template_suffix.indexOf("pre-order") === 0;
  }

  // Base scope, passed to the adapter as the raw `filters` string (via the
  // configure widget). The adapter prepends it verbatim to filter_by and joins
  // the refinement-derived clauses onto it with &&, so it COMBINES with user
  // facet refinements.
  //
  // NB: facetFilters does NOT work for this. The adapter splits each entry at
  // its LAST colon, so any entry whose *value* contains a colon is read as the
  // wrong field: "tags:vehicle_type_id:80" went out as `tags:vehicle_type_id:=[80]`
  // and matched 1276 products instead of 741 — a model page listed ~2x too many,
  // half of them parts for other cars. "collection_ids:gid://shopify/..." splits
  // at the colon in "gid:" the same way. additionalSearchParameters.filter_by is
  // no good either — the adapter replaces it with the refinement-derived
  // filter_by on the first facet click, dropping the scope.
  //
  // visibility always; the collection's own scope on collection pages.
  function tsQuote(value) {
    return "`" + String(value).replace(/`/g, "") + "`";
  }
  // "skjult" = indexed but never listed (the hidden warranty product, which otherwise
  // tops "kw v3 golf 7").
  var baseFilters = ["visibility:=" + tsQuote("all"), "tags:!=[" + tsQuote("skjult") + "]"];
  // Model-collections bruger et præcist vehicle_type_id-filter fra Shopify-metafield.
  // Metafeltet er allerede Typesense-syntaks og sendes uændret — parentes om det,
  // så et metafelt med && / || ikke kan slippe ud af sit eget led.
  // Øvrige collections fortsætter med det eksisterende collection_ids-scope.
  if (cfg.collectionFilter) baseFilters.push("(" + cfg.collectionFilter + ")");
  else if (cfg.collectionId) baseFilters.push("collection_ids:=[" + tsQuote(cfg.collectionId) + "]");
  // Med bil i Min Garage (Claus 2026-10-22): bilens dele først (sort_by _eval, ved alle sorteringer),
  // derefter kun universelle varer – aldrig dele til andre biler (window.ncFit). Et eksplicit
  // ?vehicle_type_id= i URL'en er et bevidst valg af netop den bil og filtrerer fortsat hårdt.
  var queryVehicleTypeId = new URLSearchParams(window.location.search).get("vehicle_type_id");
  var requestedVehicleTypeId = /^\d+$/.test(String(queryVehicleTypeId || "")) ? String(queryVehicleTypeId) : null;
  if (requestedVehicleTypeId) baseFilters.push("tags:=[" + tsQuote("vehicle_type_id:" + requestedVehicleTypeId) + "]");
  var fitCar = null;
  try { fitCar = window.ncVehicle.load(); } catch (e) {}
  // Samme tags som collection-siderne filtrerer på: variant (typeId), ellers model (modeller uden varianter).
  var fitTag = null;
  if (!requestedVehicleTypeId && fitCar) {
    if (/^\d+$/.test(String(fitCar.typeId || ""))) fitTag = "vehicle_type_id:" + fitCar.typeId;
    else if (/^\d+$/.test(String(fitCar.modelId || ""))) fitTag = "model_id:" + fitCar.modelId;
    else if (fitCar.makeName) fitTag = "make:" + fitCar.makeName;
  }
  function fitsCar(hit) { return !!fitTag && window.ncFit.fits(hit, fitTag); }
  if (fitTag) baseFilters.push(window.ncFit.scope(fitTag));



  // ── Typesense adapter ────────────────────────────────────────────────
  function makeAdapter(preset) {
  return new TypesenseInstantSearchAdapter({
    server: {
      apiKey: cfg.searchKey, // search-only, safe to expose
      nodes: [{ host: cfg.host, port: cfg.port || 443, protocol: cfg.protocol || "https" }],
      cacheSearchResultsForSeconds: cfg.cacheSeconds || 120,
      // Default is 5 s per attempt; a hung host must not keep the page blank. The page
      // falls back to Shopify's own results at 4 s anyway (snippets/nc-typesense-fallback).
      connectionTimeoutSeconds: 3,
    },
    // Tag-VÆRDIER indeholder kolon ("kw-serie:V3", "vehicle_type_id:80"). Uden
    // dette deler adapteren "tags:kw-serie:V3" ved SIDSTE kolon og sender
    // `tags:kw-serie:=[V3]` — et felt der ikke findes, så en valgt variant gav 0
    // produkter. Her matches feltnavnet i stedet forfra, så hele resten bliver
    // værdien: `tags:=[\`kw-serie:V3\`]`.
    facetableFieldsWithSpecialCharacters: ["tags"],
    // Applied to every query. group_by => one hit per product; `found` becomes
    // the product (group) count so pagination/stats are product-based.
    additionalSearchParameters: {
      // query_by, weights, typos and the default sort_by live in the preset on the server
      // (nardo-typesense src/search/relevance.ts); a param sent here wins over the preset.
      preset: preset,
      group_by: "product_id",
      group_limit: 1,
      highlight_full_fields: "title",
      // "Relevans". Pris/nyeste erstatter sort_by; searchClient nedenfor lægger bilens dele først dér.
      sort_by: fitTag ? window.ncFit.first(fitTag) + ",_text_match:desc" : undefined,
      // All customers reach Typesense through one proxy IP: without this, analytics merges them.
      "x-typesense-user-id": analyticsUserId(),
    },
  });
  }
  var textAdapter = makeAdapter("products_text");
  var partnoAdapter = makeAdapter("products_partno");

  // Spec facets (exhaust, suspension, tuning, brakes) — assets/nc-typesense-spec-facets.js.
  var specFacets = window.ncSpecFacets ? window.ncSpecFacets({ instantsearch: instantsearch, locale: cfg.locale }) : null;

  // Brand typos are fixed before the query leaves (window.ncFixQuery, config snippet);
  // the search box and URL keep what the customer typed.
  var fixQuery = window.ncFixQuery || function (q) { return q; };
  // Part numbers go to products_partno, with no fallback to the text search: a miss shows
  // #ts-empty, which beats a wrong part ("22-137204" would show a RaceChip). No ncFixQuery
  // on them either — it can "fix" an MPN into a brand word.
  var looksLikePartNumber = window.ncLooksLikePartNumber || function () { return false; };
  var searchClient = Object.assign({}, textAdapter.searchClient, {
    search: function (requests) {
      var q = requests[0] && requests[0].params && requests[0].params.query;
      var partno = looksLikePartNumber(q);
      return (partno ? partnoAdapter : textAdapter).searchClient.search(requests.map(function (r) {
        var i = r.indexName ? r.indexName.indexOf("/sort/") : -1;
        if (fitTag && i > -1) r = Object.assign({}, r, { indexName: r.indexName.slice(0, i + 6) + window.ncFit.first(fitTag) + "," + r.indexName.slice(i + 6) });
        if (partno || !r.params || !r.params.query) return r;
        return Object.assign({}, r, { params: Object.assign({}, r.params, { query: fixQuery(r.params.query) }) });
      }));
    },
  });

  var search = instantsearch({
    indexName: COLLECTION,
    searchClient: searchClient,
    future: { preserveSharedStateOnUnmount: true },
    routing: {
      router: instantsearch.routers.history(),
      // Keep ?q= so the URL matches Shopify's native search param + is shareable.
      stateMapping: {
        stateToRoute: function (uiState) {
          var s = uiState[COLLECTION] || {};
          var route = {
            q: s.query,
            category: s.refinementList && s.refinementList.category,
            brand: s.refinementList && s.refinementList.vendor,
            product_type: s.refinementList && s.refinementList.product_type,
            variant: s.refinementList && s.refinementList.tags,
            sale: s.toggle && s.toggle.on_sale ? "1" : undefined,
            sort: s.sortBy,
            price: s.range && s.range.price,
            // Typesense loader uendeligt; ?page= tilhører Liquid-pagineringen (crawlere,
            // og sektionen slår Typesense fra på ?page=). offset = første vare på den sidst
            // hentede side; uiState.page er 1-baseret.
            offset: s.page > 1 ? (s.page - 1) * HITS_PER_PAGE : undefined,
          };
          return specFacets ? specFacets.toRoute(s, route) : route;
        },
        routeToState: function (route) {
          var offset = parseInt(route.offset, 10);
          var state = { query: route.q, sortBy: route.sort, page: offset > 0 ? Math.floor(offset / HITS_PER_PAGE) + 1 : undefined };
          var legacyProductType = route.type && String([].concat(route.type)[0]).toLowerCase() !== "product" ? route.type : [];
          state.refinementList = {
            category: [].concat(route.category || []),
            vendor: [].concat(route.brand || []),
            product_type: [].concat(route.product_type || legacyProductType || []),
            tags: [].concat(route.variant || []),
          };
          state.toggle = { on_sale: route.sale === "1" };
          state.range = { price: route.price };
          if (specFacets) specFacets.fromRoute(route, state);
          var o = {};
          o[COLLECTION] = state;
          return o;
        },
      },
    },
  });

  var w = instantsearch.widgets;

  // ── hit (product card) template ──────────────────────────────────────
  // Uses the store's native .card-product markup so component-card.css + the
  // global nardocar card overrides style it identically to the native cards
  // (badge stack, hover image, spec table, swatches, add-to-cart, price).
  // (Native cards hide vendor + SKU via CSS, so we omit them.)

  // Badge stack — same classes/positions as card-product.liquid L194–245.
  function badgeStack(hit) {
    var out = "";

    // Sale badge (badge-sale.liquid) or pre-order fallback in the same slot.
    if (card.saleBadgeMode !== "none") {
      var onSale = hit.on_sale && hit.compare_at_price > hit.price;
      var pct = onSale
        ? Math.round(((hit.compare_at_price - hit.price) / hit.compare_at_price) * 100)
        : 0;
      if (onSale && pct > 0) {
        var saleLabel = card.saleBadgeMode === "percentage" || !card.saleBadgeMode
          ? (CARD_LABELS.salePercentage || "-[n]%").replace("[n]", pct)
          : CARD_LABELS.onSale || "Tilbud";
        out += '<div class="card-badge top left"><span class="badge badge-sale">' + esc(saleLabel) + "</span></div>";
      } else if (isPreOrder(hit)) {
        out += '<div class="card-badge top left"><span class="badge badge-sale badge-pre-order">' + esc(CARD_LABELS.preOrder || "Forudbestil") + "</span></div>";
      }
    }

    // TÜV badge (styled globally by custom.css).
    if (hit.tuv_certified === true) {
      out += '<div class="card-badge top right nardocar-tuv-badge"><span class="badge badge-tuv">TÜV</span></div>';
    }

    // Custom badges 1–3 (card-product-custom-badges.liquid): text from the
    // product, colors + days-gate from theme settings.
    var customs = "";
    var badgeSettings = card.customBadges || [];
    for (var i = 0; i < 3; i++) {
      var text = hit["custom_badge_" + (i + 1)];
      if (!text) continue;
      var b = badgeSettings[i] || {};
      var daysAgo = Number(b.daysAgo) || 0;
      if (daysAgo !== 0) {
        // Native gate: only show while the product is younger than daysAgo.
        var ageDays = typeof hit.published_at === "number"
          ? (Date.now() / 1000 - hit.published_at) / 86400
          : Infinity;
        if (!(ageDays < daysAgo)) continue;
      }
      customs +=
        '<div class="card-badge"><span class="badge" style="background-color: ' + esc(b.bg || "") +
        "; border-color: " + esc(b.bg || "") + "; color: " + esc(b.text || "") + ';">' +
        esc(text) + "</span></div>";
    }
    if (customs) out += '<div class="card-product-custom-badges">' + customs + "</div>";

    // RaceChip power badge: forøgelse i procent af originalen (+24% HK / +25% Nm), som card-product.liquid;
    // uden originalværdi vises den absolutte forøgelse.
    function powerGain(gain, stock) {
      if (!gain) return "";
      return Number(stock) > 0 ? Math.round(Number(gain) * 100 / Number(stock)) + "%" : String(gain);
    }
    var hkGain = powerGain(hit.power_hk, hit.hp_stock);
    var nmGain = powerGain(hit.power_nm, hit.nm_stock);
    if (hkGain || nmGain) {
      out +=
        '<div class="card-badge bottom left nc-power-badge">' +
        (hkGain ? '<span class="nc-pb-hk">+' + esc(hkGain) + " HK</span>" : "") +
        (nmGain ? '<span class="nc-pb-nm">+' + esc(nmGain) + " Nm</span>" : "") +
        "</div>";
    }

    // EC badge (styled globally by custom.css).
    if (hit.ec_approved === true) {
      out += '<div class="card-badge bottom right nc-ec-badge"><span class="nc-badge-ec-icon">⊕</span> EC</div>';
    }

    return out;
  }

  // Mini spec table — hit.card_specs is a JSON [{label, value}] string; output
  // matches nardocar-product-specs-mini.liquid (styled globally by custom.css).
  // Kun nøglefelterne der adskiller varerne, i fast rækkefølge — samme liste som
  // nardocar-product-specs-mini.liquid (ret begge steder). Bilmodel, modelvariant, noter
  // m.m. hører til produktsiden; TÜV/EF vises som badges. card_specs-labels er danske.
  var CARD_SPEC_LABELS = ["Årgang:", "Sænkning for:", "Sænkning bag:", "Hævning:",
    "Akseltryk for:", "Akseltryk bag:", "Hk original:", "Hk med tuning:", "Hk forøgelse:",
    "Nm original:", "Nm med tuning:", "Nm forøgelse:", "Udstødningssystem:", "Rørdiameter (mm):",
    "Akselposition:", "Dæmperdesign:"];
  function cardSpecs(specs) {
    var byLabel = {};
    specs.forEach(function (row) { if (row && row.label != null && row.value != null) byLabel[String(row.label).trim()] = row; });
    return CARD_SPEC_LABELS.map(function (label) { return byLabel[label]; }).filter(Boolean);
  }
  // Dansk decimalkomma på rene tal ("76.2" → "76,2", "3.0" → "3"); årgange
  // ("08.2014-08.2020") og intervaller ("30-60 mm") er ikke rene tal og bliver urørt.
  function decimalComma(v) {
    var m = /^(\d+)\.(\d+)(\s*\D*)$/.exec(v);
    if (!m || /[\d.\-–]/.test(m[3])) return v; // "08.2019-" er en årgang
    return /^0+$/.test(m[2]) ? m[1] + m[3] : m[1] + "," + m[2] + m[3];
  }
  function specsTable(hit) {
    var specs = parseJSONField(hit.card_specs);
    if (!Array.isArray(specs)) return "";
    var rows = "";
    var inch = null;
    specs.forEach(function (row) { if (row && String(row.label).trim() === "Rørdiameter (tommer):") inch = row.value; });
    cardSpecs(specs).forEach(function (row) {
      // Som nc-spec-value short: "op til 30 mm" → "≤ 30 mm", "min. 30 mm" → "≥ 30 mm";
      // akseltryk er altid et maksimum, så "op til 970 kg" → "970 kg".
      var upTo = /^akseltryk/i.test(row.label) ? "" : "≤ ";
      var value = decimalComma(String(row.value).replace(/^op til\s+/i, upTo).replace(/^min\.\s+/i, "≥ "));
      var label = row.label;
      // Som snippets/nc-pipe-diameter: 76,2 mm (3").
      if (label === "Rørdiameter (mm):") {
        label = "Rørdiameter:";
        value += " mm" + (inch != null && inch !== "" ? " (" + decimalComma(String(inch)) + '")' : "");
      }
      // Effekt altid i kW og hk (assets/nc-power.js, som snippets/nc-spec-value/-rows):
      // "Hk original: 170 hk" → "Effekt original: 125 kW (170 hk)". RaceChip uændret (ejerens beslutning).
      if (/^Hk /.test(label) && hit.vendor !== "Racechip") {
        value = window.ncPower(value);
        label = { "Hk original:": "Effekt original:", "Hk med tuning:": "Effekt med tuning:", "Hk forøgelse:": "Effektforøgelse:" }[label] || label;
      }
      // Indeksets labels/ja-nej er danske; vis dem i butikkens sprog (cfg.specLabels, DK = uændret).
      var SL = cfg.specLabels || {};
      label = SL[label] || label;
      value = SL[value] || value;
      rows += "<tr><td>" + esc(label) + "</td><td>" + esc(value) + "</td></tr>";
    });
    return rows
      ? '<div class="nc-card-specs"><table class="nc-specs-table">' + rows + "</table></div>"
      : "";
  }

  // Swatches — hit.swatches is a JSON [{option, values:[{value, image?}]}]
  // string; visual-only (links to the product), mirrors the visible output of
  // card-product-swatches.liquid (reversed options, per-option cap + "+N mere").
  function swatchList(hit, href) {
    if (!card.showSwatches) return "";
    var groups = parseJSONField(hit.swatches);
    if (!Array.isArray(groups) || !groups.length) return "";
    var max = Number(card.swatchesMax) > 0 ? Number(card.swatchesMax) : 12;
    var out = "";
    groups.slice().reverse().forEach(function (group) {
      if (!group || SWATCH_OPTIONS.indexOf(group.option) === -1) return;
      var values = Array.isArray(group.values) ? group.values : [];
      if (values.length <= 1) return;
      values.slice(0, max).forEach(function (v) {
        if (!v || v.value == null) return;
        var style = "";
        // A mapped color (settings.color_swatches) beats the indexed image: that
        // image is the variant's product photo, unreadable at swatch size.
        if (SWATCH_COLORS[v.value]) {
          style = "background-color: " + SWATCH_COLORS[v.value];
        } else if (v.image) {
          // Quote + CSS-escape the url so ')' or quotes in an indexed image
          // string can't break out of the declaration; esc() below re-escapes
          // for the HTML attribute context.
          style = 'background-image: url("' + String(v.image).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '")';
        }
        out +=
          '<a href="' + href + '" class="color-swatch card-product-color-swatch nc-btn-auto" data-value="' +
          esc(v.value) + '" data-tooltip="' + esc(v.value) + '"' +
          (style ? ' style="' + esc(style) + '"' : "") + ">" + esc(v.value) + "</a>";
      });
      if (values.length > max) {
        out +=
          '<a class="card-product-color-swatch-more-text" href="' + href + '">' +
          esc((CARD_LABELS.moreSwatches || "+ [n] mere").replace("[n]", values.length - max)) +
          "</a>";
      }
    });
    return out ? '<div class="card-product-color-swatches">' + out + "</div>" : "";
  }

  // Add-to-cart CTA — ports card-product-add-to-cart.liquid. Single variant +
  // available renders the native <product-form> markup: the globally registered
  // product-form component (product-form.js, loaded by sections/header.liquid)
  // wires the submit → POST /cart/add + mini-cart drawer render, identical to
  // native cards. Multi-variant links to the product ("Vælg Variant").
  function cardActions(hit, href) {
    if (!card.showAddToCart) return "";
    if (typeof hit.variants_count !== "number") return "";
    var btnClass = "button button-" + (card.addToCartStyle || "solid");
    function chooseVariant() {
      return (
        '<div class="product-actions card-product-actions"><div class="product-actions-add-to-cart">' +
        '<a href="' + href + '" class="' + btnClass + ' js-product-link">' + esc(CARD_LABELS.chooseOptions || "Vælg variant") + "</a>" +
        "</div></div>"
      );
    }
    if (hit.variants_count > 1) return chooseVariant();
    var variantId = numericId(hit.variant_id);
    if (!variantId) return chooseVariant();
    var label = isPreOrder(hit) ? (CARD_LABELS.preOrder || "Forudbestil") : (CARD_LABELS.addToCart || "Tilføj til kurv");
    return (
      "<product-form>" +
        '<form method="post" action="/cart/add" data-type="add-to-cart-form" data-event-context="ProductCardTypesense" novalidate="novalidate">' +
          '<input type="hidden" name="id" value="' + variantId + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<div class="product-actions card-product-actions"><div class="product-actions-add-to-cart">' +
            '<button type="submit" name="add" class="' + btnClass + ' button-add-to-cart">' +
              "<span>" + esc(label) + "</span>" +
              '<div class="button-overlay-spinner hidden"><span class="spinner-xs"></span></div>' +
            "</button>" +
          "</div></div>" +
          '<div class="product-form-error-message-wrapper form-status form-status-error" role="alert" hidden><span class="product-form-error-message"></span></div>' +
        "</form>" +
      "</product-form>"
    );
  }

  // Shopify-CDN skalerer via ?width=; uden den hentes originalen (op til 2500 px) til et kort på ~180 px.
  function cdnWidth(url, w) {
    if (!url || !/\/\/(cdn\.shopify\.com|[^/]+\/cdn\/shop)\//.test(url)) return url;
    var base = url.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "");
    return base + (base.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  function cdnSrcset(url) {
    return [300, 400, 600].map(function (w) { return cdnWidth(url, w) + " " + w + "w"; }).join(", ");
  }

  function hitTemplate(hit) {
    var img = hit.featured_image || (hit.images && hit.images[0]) || card.placeholderImage || "";
    // Hover second image, like native (settings.products_show_secondary_image).
    var img2 = card.showSecondaryImage && Array.isArray(hit.product_images)
      ? hit.product_images[1]
      : null;
    var onSale = hit.on_sale && hit.compare_at_price > hit.price;
    var title =
      hit._highlightResult && hit._highlightResult.title
        ? hit._highlightResult.title.value
        : esc(hit.title);
    var href = window.ncVehicle.url("/products/" + encodeURIComponent(hit.handle));

    // Native media markup: .aspect-ratio wrapper stacks the two .card-media-image
    // imgs (base.css positions them; component-card.css does the hover swap).
    var media = img
      ? '<div class="aspect-ratio" style="--ratio-percent: 100%;">' +
          '<img class="card-media-image" ' + (hit.__position && hit.__position <= 4 ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') + ' src="' + esc(cdnWidth(img, 400)) + '" srcset="' + esc(cdnSrcset(img)) + '" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(hit.title) + '" width="300" height="300">' +
          (img2 ? '<img class="card-media-image" loading="lazy" src="' + esc(cdnWidth(img2, 400)) + '" srcset="' + esc(cdnSrcset(img2)) + '" sizes="(min-width: 990px) 25vw, 50vw" alt="" width="300" height="300">' : "") +
        "</div>"
      : '<span class="ts-noimg"></span>';

    var badges = badgeStack(hit);

    // Price — snippets/price.liquid classes (component-price.css hides
    // .price-on-sale .price-regular, so the regular block always renders).
    var priceHtml =
      '<div class="price' + (onSale ? " price-on-sale" : "") + '">' +
        '<div class="price-container">' +
          '<div class="price-regular"><span class="price-item price-item-regular">' + money.format(hit.price) + "</span></div>" +
          (onSale
            ? '<div class="price-sale">' +
                '<span><s class="price-item price-item-regular">' + money.format(hit.compare_at_price) + "</s></span>" +
                '<span class="price-item price-item-sale price-item-last">' + money.format(hit.price) + "</span>" +
              "</div>"
            : "") +
        "</div>" +
      "</div>";

    return (
      '<div class="card card-product" data-product-id="' + esc(numericId(hit.product_id)) + '"' +
        // Typesense document id == the variant GID; the analytics counters key off it.
        (hit.variant_id ? ' data-variant-gid="' + esc(hit.variant_id) + '"' : "") + ">" +
        '<figure class="card-media card-media-contain">' +
          '<a href="' + href + '" class="js-product-link" aria-label="' + esc(hit.title) + '">' + media + "</a>" +
          (badges ? '<div class="card-product-badges">' + badges + "</div>" : "") +
        "</figure>" +
        '<div class="card-info-wrap">' +
          '<div class="card-info">' +
            // Single <span> wrapper: the global mobile .js-product-link rule makes
            // the anchor a flex container, which would otherwise split the title
            // around the <mark> highlight into columns.
            '<h3 class="card-heading"><a class="js-product-link" href="' + href + '"' + carTitleAttrs(hit) + '><span>' + title + "</span></a></h3>" +
            swatchList(hit, href) +
          "</div>" +
          '<div class="card-footer">' +
            priceHtml +
            specsTable(hit) +
            cardActions(hit, href) +
          "</div>" +
        "</div>" +
      "</div>"
    );
  }

  // ── widgets ──────────────────────────────────────────────────────────
  // Varianter: brand-serie-tags følger konventionen {brand-slug}-serie:{variant},
  // fx "kw-serie:V3", "bilstein-serie:B14". Brand-slug'en er mærkenavnet i små
  // bogstaver uden &, med alt ikke-alfanumerisk slået sammen til "-"
  // ("H&R" → "hr", "TA-Technix" → "ta-technix").
  function formatSeriesLabel(label) {
    return String(label || "")
      .replace(/-/g, " ")
      .replace(/([A-Za-z])(\d)/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim();
  }
  // Listen giver kun mening inden for ét mærke — to mærker ville blande fx V3 og
  // B14 sammen. Uden præcis ét valgt mærke returneres null, og facetten skjules.
  function seriesPrefix() {
    // Brand collections have an authoritative prefix from Liquid even when the
    // vendor checkbox is not selected (for example RaceChip Chiptuning).
    if (typeof cfg.defaultSeriesPrefix === "string" && cfg.defaultSeriesPrefix) {
      return cfg.defaultSeriesPrefix;
    }
    var state = search.helper && search.helper.state;
    var brands = (state && state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements.vendor) || [];
    if (brands.length !== 1) return null;
    return brands[0].toLowerCase()
      .replace(/&/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") + "-serie:";
  }


  // Map InstantSearch refinement-list nodes onto the store's native facet
  // classes so the global nardocar facet CSS styles them (these are *added* to
  // the default .ais-* classes, not replacements).
  var FACET_CSS_CLASSES = {
    label: "checkbox-facet-label",
    labelText: "checkbox-facet-label-text",
    count: "checkbox-facet-label-count",
    showMore: "facet-button-more nc-btn-auto",
  };
  // Custom item template so the count is formatted da-DK ("3.489") regardless of
  // the JS runtime's default locale (which renders "3,489" — wrong for Danish).
  // Mirrors the default refinement-list item structure so click-to-refine + the
  // native facet classes keep working.
  function refinementItem(item) {
    return (
      '<label class="ais-RefinementList-label checkbox-facet-label">' +
        '<input type="checkbox" class="ais-RefinementList-checkbox" value="' +
          esc(item.value) + '"' + (item.isRefined ? " checked" : "") + ">" +
        '<span class="ais-RefinementList-labelText checkbox-facet-label-text">' +
          esc(item.label) + "</span>" +
        '<span class="ais-RefinementList-count checkbox-facet-label-count">' +
          num.format(item.count) + "</span>" +
      "</label>"
    );
  }
  // "+ Vis mere / − Vis mindre" (native "+ VIS MERE"); CSS uppercases it.
  var FACET_TEMPLATES = {
    item: refinementItem,
    showMoreText:
      "{{#isShowingMore}}− " + L.showLess + "{{/isShowingMore}}{{^isShowingMore}}+ " + L.showMore + "{{/isShowingMore}}",
  };

  // ── dual-range price slider ──────────────────────────────────────────
  // Custom connectRange widget rendering the native .nc-elite-price-range markup
  // (two overlapping range thumbs + min/max number fields), styled globally by
  // nardocar-css-layout-typography. State kept in a closure so handlers always
  // read the latest bounds/refine.
  var priceState = { min: 0, max: 0, refine: function () {} };
  function renderPriceSlider(opts, isFirst) {
    var el = document.querySelector("#ts-price");
    if (!el) return;
    var min = Math.floor(opts.range.min != null ? opts.range.min : 0);
    var max = Math.ceil(opts.range.max != null ? opts.range.max : 0);
    // A handful of products cost 100× the median, which squashes the usable part
    // of the track to nothing. Cap the slider (cfg.priceMax, 0 = uncapped); at the
    // cap no upper bound is sent, so the expensive products are still in results.
    if (cfg.priceMax > 0) max = Math.min(max, cfg.priceMax);
    priceState.min = min;
    priceState.max = max;
    priceState.refine = opts.refine;
    if (max <= min) { el.innerHTML = ""; priceState.refs = null; return; }

    var curMin = opts.start[0] === -Infinity || opts.start[0] == null ? min : Math.max(min, Math.floor(opts.start[0]));
    var curMax = opts.start[1] === Infinity || opts.start[1] == null ? max : Math.min(max, Math.ceil(opts.start[1]));

    if (isFirst || !priceState.refs || !el.querySelector(".nc-elite-range-min")) {
      var aMin = esc(L.priceFrom);
      var aMax = esc(L.priceTo);
      var cur = esc(CURRENCY);
      el.innerHTML =
        '<div class="nc-elite-price-range">' +
          '<div class="nc-elite-price-inputs">' +
            '<div class="nc-elite-price-field"><input type="number" class="nc-elite-num-min" inputmode="numeric" aria-label="' + aMin + '"><span class="nc-elite-currency">' + cur + "</span></div>" +
            '<span class="nc-elite-separator">–</span>' +
            '<div class="nc-elite-price-field"><input type="number" class="nc-elite-num-max" inputmode="numeric" aria-label="' + aMax + '"><span class="nc-elite-currency">' + cur + "</span></div>" +
          "</div>" +
          '<div class="nc-elite-slider-wrap">' +
            '<input type="range" class="nc-elite-range nc-elite-range-min" aria-label="' + aMin + '">' +
            '<input type="range" class="nc-elite-range nc-elite-range-max" aria-label="' + aMax + '">' +
          "</div>" +
        "</div>";
      var refs = {
        rMin: el.querySelector(".nc-elite-range-min"),
        rMax: el.querySelector(".nc-elite-range-max"),
        nMin: el.querySelector(".nc-elite-num-min"),
        nMax: el.querySelector(".nc-elite-num-max"),
      };
      priceState.refs = refs;

      var sync = function (source) {
        var lo = Number(refs.rMin.value);
        var hi = Number(refs.rMax.value);
        if (source === "min" && lo > hi) { lo = hi; refs.rMin.value = lo; }
        if (source === "max" && hi < lo) { hi = lo; refs.rMax.value = hi; }
        refs.nMin.value = lo;
        refs.nMax.value = hi;
      };
      var commit = function () {
        var lo = Number(refs.rMin.value);
        var hi = Number(refs.rMax.value);
        priceState.refine([lo <= priceState.min ? undefined : lo, hi >= priceState.max ? undefined : hi]);
      };
      refs.rMin.addEventListener("input", function () { sync("min"); });
      refs.rMax.addEventListener("input", function () { sync("max"); });
      refs.rMin.addEventListener("change", commit);
      refs.rMax.addEventListener("change", commit);
      refs.nMin.addEventListener("change", function () {
        var v = Math.max(priceState.min, Math.min(Number(refs.nMin.value) || priceState.min, Number(refs.rMax.value)));
        refs.rMin.value = v; sync("min"); commit();
      });
      refs.nMax.addEventListener("change", function () {
        var v = Math.min(priceState.max, Math.max(Number(refs.nMax.value) || priceState.max, Number(refs.rMin.value)));
        refs.rMax.value = v; sync("max"); commit();
      });
    }

    var r = priceState.refs;
    r.rMin.min = r.rMax.min = min;
    r.rMin.max = r.rMax.max = max;
    r.rMin.step = r.rMax.step = 1;
    r.rMin.value = curMin;
    r.rMax.value = curMax;
    r.nMin.value = curMin;
    r.nMax.value = curMax;
  }
  var priceSlider = instantsearch.connectors.connectRange(renderPriceSlider);

  // Headless search box: no UI (the theme header already has search), but it
  // registers the `query` ui-state so the ?q= read by the history router below
  // is actually applied to the search. Without a mounted search box widget,
  // InstantSearch ignores the routed query and returns the whole catalog.
  var virtualSearchBox = instantsearch.connectors.connectSearchBox(function () {});

  // Bil i Min Garage, men intet i søgeresultatet passer: sig det over listen.
  var fitNoticeEl = null;
  var lastFits = {}; // side → passer sidens sidste hit (til skillelinjen ved sidegrænser)
  function fitNotice(show) {
    if (!fitTag || !fitCar.typeName || !L.fitSearchNotice) return;
    if (!fitNoticeEl) {
      var hitsBox = document.getElementById("ts-hits");
      if (!hitsBox) return;
      fitNoticeEl = document.createElement("p");
      fitNoticeEl.className = "nc-fit-notice";
      fitNoticeEl.setAttribute("role", "status");
      fitNoticeEl.innerHTML = esc(L.fitSearchNotice).replace(/\[car\]/g, "<strong>" + esc(fitCar.typeName) + "</strong>");
      hitsBox.parentNode.insertBefore(fitNoticeEl, hitsBox);
    }
    fitNoticeEl.hidden = !show;
  }

  var widgets = [
    w.configure({ hitsPerPage: HITS_PER_PAGE, maxValuesPerFacet: 1000, filters: baseFilters.join(" && ") }),

    virtualSearchBox(),

    w.sortBy({
      container: "#ts-sort",
      // Native sort <select> styling via the global .nc-toolbar-sort-select.
      cssClasses: { select: "nc-toolbar-sort-select" },
      // No "Popularitet" option: `popularity` is 0 on every document until
      // Typesense runs with --enable-search-analytics (see the counter rules below).
      items: [
        { label: L.relevance, value: COLLECTION },
        { label: L.priceAsc, value: COLLECTION + "/sort/price:asc" },
        { label: L.priceDesc, value: COLLECTION + "/sort/price:desc" },
        { label: L.newest, value: COLLECTION + "/sort/created_at:desc" },
      ],
    }),

    // "Ryd alle": i værktøjslinjen på desktop, i filterskuffens bund på mobil.
    w.clearRefinements({
      container: "#ts-clear",
      templates: { resetLabel: L.clearAll },
      cssClasses: { button: "nc-btn-auto" },
    }),
    w.clearRefinements({
      container: "#ts-clear-drawer",
      templates: { resetLabel: L.clearAll },
      cssClasses: { button: "nc-btn-auto" },
    }),

    // Top-level shop category (5 values) — sits above Mærke/Produkttype.
    w.refinementList({
      container: "#ts-category",
      attribute: "category",
      sortBy: ["name:asc"],
      limit: 10,
      cssClasses: FACET_CSS_CLASSES,
      templates: FACET_TEMPLATES,
    }),
    w.refinementList({
      container: "#ts-vendor",
      attribute: "vendor",
      // Native facets: alphabetical, no per-facet search box, "+ VIS MERE" to expand.
      sortBy: ["name:asc"],
      limit: 8,
      showMore: true,
      showMoreLimit: 30,
      cssClasses: FACET_CSS_CLASSES,
      templates: FACET_TEMPLATES,
    }),

    w.refinementList({
      container: "#ts-type",
      attribute: "product_type",
      sortBy: ["name:asc"],
      limit: 8,
      showMore: true,
      showMoreLimit: 30,
      cssClasses: FACET_CSS_CLASSES,
      templates: FACET_TEMPLATES,
    }),
    priceSlider({ container: "#ts-price", attribute: "price" }),
    w.toggleRefinement({
      container: "#ts-onsale",
      attribute: "on_sale",
      on: "true",
      templates: {
        labelText: function(data) {
          // Vis kun "Tilbud", når mindst én vare i den aktuelle visning reelt er på tilbud (eller filteret er valgt).
          var box = document.getElementById("ts-onsale");
          var n = data && data.onFacetValue ? data.onFacetValue.count : 0;
          if (box) box.hidden = !(n > 0 || (data && data.isRefined));
          return L.onSale || "Tilbud";
        },
      },
      cssClasses: { label: "checkbox-facet-label", labelText: "checkbox-facet-label-text" },
    }),
    w.infiniteHits({
      container: "#ts-hits",
      // Delte links med ?offset= starter midt i listen; loadOffsetLink nedenfor henter
      // varerne før via showPrevious. Knappen er skjult (CSS).
      showPrevious: true,
      transformItems: function (items, meta) {
        // Bilens dele står forrest ved alle sorteringer (sort_by _eval): passer første hit på
        // side 1 ikke, passer intet – resten er universelle varer.
        var r = meta && meta.results;
        // Andre bilers varer, som kun er knyttet via et numerisk fit-id (kan ikke filtreres i Typesense).
        if (fitTag) items = items.filter(function (hit) { return window.ncFit.keep(hit, fitTag); });
        if (r && r.page === 0) fitNotice(items.length > 0 && !fitsCar(items[0]));
        if (!r || !fitTag || !items.length) return items;
        // Overskrift over bilens dele og en skillelinje med egen overskrift før resten,
        // lagt ind som ekstra elementer i listen. Intet mærke på det enkelte kort.
        // shortcut: skiftet ved en sidegrænse kræver den forrige side (ikke kendt ved ?offset=-links).
        lastFits[r.page] = fitsCar(items[items.length - 1]);
        var out = [];
        items.forEach(function (hit, i) {
          var prevFits = i > 0 ? fitsCar(items[i - 1]) : r.page > 0 && lastFits[r.page - 1] === true;
          if (i === 0 && r.page === 0 && fitsCar(hit)) out.push({ objectID: "nc-group-match", ncGroup: "match" });
          else if (prevFits && !fitsCar(hit)) out.push({ objectID: "nc-group-rest", ncGroup: "rest" });
          out.push(hit);
        });
        return out;
      },
      templates: {
        item: function(hit) {
          if (!hit.ncGroup) return hitTemplate(hit);
          return '<p class="nc-ts-group nc-ts-group--' + hit.ncGroup + '">' + esc(hit.ncGroup === "match" ? L.groupMatch : L.groupRest) + "</p>";
        },
        // Help block rendered by the section (<template id="ts-empty">): query, spelling
        // hint, category links, contact line.
        empty: function (results) {
          // The helper holds what the customer typed (results.query may be the fixed one).
          var q = esc(search.mainIndex.getHelper().state.query || (results && results.query) || "");
          var tpl = document.getElementById("ts-empty");
          var put = function () { return q; }; // function: "$&" in a query must stay literal
          return tpl ? tpl.innerHTML.replace(/\[terms\]/g, put) : '<p class="ts-no-results">' + esc(L.noResults || "").replace("[terms]", put) + "</p>";
        },
        showMoreText: function(data) {
          if (data.isLastPage) return "";
          var label = esc(L.showMore || "Vis mere");
          // Byg progressbar og et synligt handlingsnavn. Adapteren kan mangle
          // nbHits i den første render, men knappen skal aldrig være tom.
          var total = Number(data.nbHits || 0);
          // Adapteren kan transient returnere 0 trods rendererede kort. Vis aldrig en falsk “0 af 0”-status.
          if (!total) return '<span class="ts-load-more__label">' + label + '</span>';
          var shown = Math.min((data.currentPageHits || 0) + (data.page || 0) * (data.hitsPerPage || 24), total);
          var pct = Math.round((shown / total) * 100);
          return (
            '<div class="nc-pagination-wrap">' +
              '<div class="nc-pagination-info">' +
                '<span class="nc-pagination-count">Viser <strong>' + shown + '</strong> af <strong>' + total + '</strong> produkter</span>' +
              '</div>' +
              '<div class="nc-pagination-bar-track">' +
                '<div class="nc-pagination-bar-fill" style="width:' + pct + '%"></div>' +
              '</div>' +
            '</div>' +
            '<span class="ts-load-more__label">' + label + '</span>'
          );
        },
      },
      cssClasses: {
        root: "ts-hits-root",
        list: "ais-InfiniteHits-list",
        item: "ais-InfiniteHits-item",
        loadMore: "nc-btn-auto ts-load-more",
        disabledLoadMore: "nc-btn-auto ts-load-more ts-load-more--disabled",
        loadPrevious: "ts-load-previous",
      },
    }),

  ];

  // Varianter — serie-tags for det valgte mærke (kw-serie:V3, bilstein-serie:B14 …).
  // Counts og værdier kommer fra hovedforespørgslen, så de altid følger collection-
  // scope og de øvrige aktive filtre. Facetten findes kun på collection-siden;
  // søgesiden har ingen #ts-variants, og refinementList kaster på en manglende
  // container, så widget'en tilføjes kun når beholderen er der.
  if (document.getElementById("ts-variants")) {
    widgets.push(w.refinementList({
      container: "#ts-variants",
      // Ét fælles tags-felt rummer alle tag-typer (model_id:, kategori:, tuv: …),
      // så listen indsnævres til mærkets serie-præfiks her i klienten.
      attribute: "tags",
      sortBy: ["name:asc"],
      // tags har høj kardinalitet, og Typesense returnerer kun top-N værdier.
      // Målt på et mærke-scope uden bilfilter falder fx "kw-serie:V4" ud ved 30;
      // ved 100 er alle ni serier med. 200 giver luft uden mærkbar payload.
      limit: 1000,
      cssClasses: FACET_CSS_CLASSES,
      templates: FACET_TEMPLATES,
      transformItems: function (items) {
        var prefix = seriesPrefix();
        if (!prefix) return [];
        return items
          .filter(function (item) { return item.value.indexOf(prefix) === 0; })
          .map(function (item) {
            return Object.assign({}, item, { label: formatSeriesLabel(item.label.slice(prefix.length)) });
          });
      },
    }));
  }

  if (specFacets) widgets = widgets.concat(specFacets.widgets(FACET_CSS_CLASSES, FACET_TEMPLATES));
  search.addWidgets(widgets);

  // ?offset=N (delt link): vis offset-siden straks, øverst under værktøjslinjen, og hent
  // så siderne før den. De lægges ind over det synlige, og scroll-positionen rettes efter
  // hver side, så offset-varerne står stille (som når en chat henter ældre beskeder).
  // ponytail: én forespørgsel pr. tidligere side; de ligger uden for skærmen.
  (function loadOffsetLink() {
    var offset = parseInt(new URLSearchParams(window.location.search).get("offset"), 10);
    if (!(offset > 0)) return;
    var anchorHref = null, anchorTop = 0;
    function anchor() {
      var link = anchorHref && document.querySelector('#ts-hits .ais-InfiniteHits-item a[href="' + anchorHref + '"]');
      return link && link.closest(".ais-InfiniteHits-item");
    }
    function rememberAnchor() {
      var el = anchor();
      if (el) anchorTop = el.getBoundingClientRect().top;
    }
    search.on("render", function onRender() {
      var state = search.renderState[COLLECTION] && search.renderState[COLLECTION].infiniteHits;
      if (!state || !state.results || search.status !== "idle") return;
      var el = anchor();
      if (!el) {
        // Første svar: offset-siden er hele listen. Første vare = ankeret.
        // Første kort med link (en gruppeoverskrift kan stå først).
        var link = document.querySelector("#ts-hits .ais-InfiniteHits-item a[href]");
        var first = link && link.closest(".ais-InfiniteHits-item");
        if (!link) { search.removeListener("render", onRender); return; }
        anchorHref = link.getAttribute("href");
        // Listen er først synlig efter denne render: scroll i næste frame, lige under
        // den sticky værktøjslinje (instant: html har scroll-behavior: smooth).
        requestAnimationFrame(function () {
          var bar = document.querySelector(".nc-collection-toolbar");
          anchorTop = (bar ? bar.offsetHeight : 0) + 16;
          window.scrollBy({ top: first.getBoundingClientRect().top - anchorTop, behavior: "instant" });
          window.addEventListener("scroll", rememberAnchor, { passive: true });
        });
      } else {
        // Hold ankeret samme sted på skærmen, når en tidligere side er lagt ind over.
        window.scrollBy({ top: el.getBoundingClientRect().top - anchorTop, behavior: "instant" });
      }
      if (!state.isFirstPage) { state.showPrevious(); return; }
      search.removeListener("render", onRender);
      window.removeEventListener("scroll", rememberAnchor);
    });
  })();

  // Filter-sidebaren (sticky, se typesense-search.css) slutter altid ved skærmens bund, også
  // før den har nået sin sticky-position, så bunden af filterlisten kan nås uden at scrolle siden.
  (function fitSidebarToViewport() {
    var aside = document.querySelector(".ts-search__facets");
    var desktop = window.matchMedia("(min-width: 990px)");
    if (!aside) return;
    var queued = false;
    function fit() {
      queued = false;
      aside.style.maxHeight = desktop.matches
        ? Math.max(200, window.innerHeight - Math.max(aside.getBoundingClientRect().top, 0) - 16) + "px"
        : "";
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(fit); } }
    window.addEventListener("scroll", queue, { passive: true });
    window.addEventListener("resize", queue);
    // Indhold over sidebaren (bannere, resultater) flytter dens top efter første paint.
    if ("ResizeObserver" in window) new ResizeObserver(queue).observe(document.body);
    fit();
  })();

  // Typesense down/erroring: hand over to the server-rendered Shopify results at once
  // (snippets/nc-typesense-fallback) instead of waiting for the 4 s timeout.
  search.on("error", function () {
    window.ncTsFailed = true;
    document.dispatchEvent(new CustomEvent("nc:ts-error"));
  });
  // Antal varer til filterskuffens knap "Vis X varer" (assets/nc-facets-sheet.js).
  search.on("render", function () { var r = search.helper && search.helper.lastResults; if (r) document.dispatchEvent(new CustomEvent("nc:ts-count", { detail: r.nbHits })); });
  // Sorteringens dropdown: navnet fra værktøjslinjen, da teksten "Sortér efter" ikke vises.
  search.on("render", function () { var w = document.querySelector("[data-sort-label]"), sel = w && w.querySelector("select"); if (sel) sel.setAttribute("aria-label", w.dataset.sortLabel); });
  search.start();
  if (specFacets) specFacets.attach(search);
  // Adapteren kan være klar efter første initiale render. Kør højst to sekventielle,
  // read-only queries og stop straks, når der enten findes produktkort eller en ægte tomtilstand.
  function recoverInitialCollectionQuery(attempt) {
    var initialHits = document.getElementById("ts-hits");
    var hasInitialCards = initialHits && initialHits.querySelector(".card-product, .ais-Hits-item, [data-product-id]");
    var hasNativeEmptyState = initialHits && initialHits.textContent.trim().length > 0;
    if (hasInitialCards || hasNativeEmptyState || !search.helper) return;
    search.helper.setQuery(search.helper.state.query || "").setPage(0).search();
    if (attempt < 2) window.setTimeout(function () { recoverInitialCollectionQuery(attempt + 1); }, 1500);
  }
  window.setTimeout(function () { recoverInitialCollectionQuery(1); }, 1500);

  // ── NC INFINITE SCROLL ────────────────────────────────────────────────────
  // Automatisk indlæsning af næste side når brugeren scroller til bunden.
  // Observerer "Vis mere"-knappen og klikker den automatisk.
  (function setupInfiniteScroll() {
    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var btn = document.querySelector(".ts-load-more:not(.ts-load-more--disabled)");
          if (btn) {
            btn.click();
          }
        });
      },
      { rootMargin: "400px 0px", threshold: 0 }
    );

    // Opret sentinel-element under produktgitteret
    function attachSentinel() {
      var hits = document.getElementById("ts-hits");
      if (!hits) return;
      var existing = document.getElementById("nc-ts-sentinel");
      if (existing) return;
      var sentinel = document.createElement("div");
      sentinel.id = "nc-ts-sentinel";
      sentinel.style.cssText = "height:1px;width:100%;display:block;pointer-events:none;";
      hits.parentNode && hits.parentNode.insertBefore(sentinel, hits.nextSibling);
      observer.observe(sentinel);
    }

    // Vent til Typesense har renderet produkterne
    setTimeout(attachSentinel, 1500);
    setTimeout(attachSentinel, 3000);
  })();
  // ── Typesense analytics counters (<collection>_click / _purchase) ─────
  // Fire-and-forget, with window.nardoSearch.analyticsKey (events only). Analytics
  // is on server-side since 2026-10-27.
  // window.ncTsUserId: config snippet, shared with the search requests and the header.
  function analyticsUserId() { return window.ncTsUserId ? window.ncTsUserId() : "anonymous"; }
  function track(suffix, eventType, docId) {
    if (!docId) return;
    fetch("https://" + cfg.host + "/analytics/events", {
      method: "POST",
      keepalive: true, // survives the navigation the click triggers
      headers: {
        "Content-Type": "application/json",
        "X-TYPESENSE-API-KEY": cfg.analyticsKey || cfg.searchKey,
      },
      body: JSON.stringify({
        name: COLLECTION + suffix,
        event_type: eventType,
        data: { doc_id: docId, user_id: analyticsUserId() },
      }),
    }).catch(function () {});
  }
  var hitsEl = document.querySelector("#ts-hits");
  if (hitsEl) {
    var gidOf = function (target) {
      var el = target && target.closest ? target.closest("[data-variant-gid]") : null;
      return el && el.getAttribute("data-variant-gid");
    };
    hitsEl.addEventListener("click", function (e) { track("_click", "click", gidOf(e.target)); });
    // ponytail: fires on submit, not on a confirmed cart response — product-form.js
    // exposes no success event. Move it onto one if false conversions ever matter.
    hitsEl.addEventListener("submit", function (e) { track("_purchase", "conversion", gidOf(e.target)); });
  }

  // Let the header search input live-drive these results (nardocar-header-search.js).
  window.nardoSearchSetQuery = function (q) {
    search.helper.setQuery(q == null ? "" : q).setPage(0).search();
  };

  // Toolbar "Sorter" button toggles the facet sidebar (mirrors the native
  // collection toolbar, whose JS only runs on collection pages).
  var filterBtn = document.querySelector("[data-ts-filter-toggle]");
  var body = document.querySelector("[data-ts-body]");
  var isMobile = function () { return window.matchMedia("(max-width: 989px)").matches; };
  function openDrawer() {
    body.classList.add("ts-facets-open");
    document.body.classList.add("ts-drawer-lock");
    filterBtn.setAttribute("aria-expanded", "true");
  }
  function closeDrawer() {
    body.classList.remove("ts-facets-open");
    document.body.classList.remove("ts-drawer-lock");
    filterBtn.setAttribute("aria-expanded", "false");
  }
  if (filterBtn && body) {
    filterBtn.addEventListener("click", function () {
      // Mobile: open the facet drawer. Desktop: collapse the sidebar (extra column).
      if (isMobile()) {
        if (body.classList.contains("ts-facets-open")) closeDrawer();
        else openDrawer();
        return;
      }
      var open = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", open ? "false" : "true");
      this.classList.toggle("is-active", !open);
      body.classList.toggle("ts-facets-hidden", open);
    });
    document.querySelectorAll("[data-ts-facets-close]").forEach(function (el) {
      el.addEventListener("click", closeDrawer);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
    // If the viewport grows back to desktop, make sure the drawer/lock is cleared.
    window.addEventListener("resize", function () { if (!isMobile()) closeDrawer(); });
  }



  // Collapsible facet sections (each .ts-facet__title toggles its content).
  document.querySelectorAll(".ts-facet__title").forEach(function (title) {
    title.addEventListener("click", function () {
      var expanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", expanded ? "false" : "true");
    });
  });
  } // end runSearch

  // Start med retry (op til 25 forsøg = 5 sekunder)
  var _started = false;
  function startOnce() {
    if (_started) return;
    _started = true;
    tryInit(25);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startOnce);
  } else {
    startOnce();
  }
  // Backup: start også ved window.load (sikrer at alle scripts er loadet)
  window.addEventListener('load', startOnce);
})();
